import moment from 'moment-timezone';

export const tzMap = {
  // Added US territory and Pacific timezones
  "UTC−12:00 (AoE)": "Etc/GMT+12", // Baker Island and Howland Island
  "UTC−12:00 (AoE) – Baker Island and Howland Island": "Etc/GMT+12",
  "UTC−11:00 (ST)": "Pacific/Pago_Pago", // American Samoa, Jarvis Island, Kingman Reef, Midway Atoll and Palmyra Atoll
  "UTC−11:00 (ST) – American Samoa, Jarvis Island, Kingman Reef, Midway Atoll and Palmyra Atoll": "Pacific/Pago_Pago",
  "UTC−10:00 (HT) – Hawaii, most of the Aleutian Islands, and Johnston Atoll": "Pacific/Honolulu",
  "UTC−09:00 (AKT) – Most of the state of Alaska": "America/Anchorage",
  "UTC−08:00 (PT) – Pacific Time zone: the Pacific coast states, the Idaho Panhandle and most of Nevada and Oregon": "America/Los_Angeles",
  "UTC−07:00 (MT) – Mountain Time zone: most of Idaho, part of Oregon, and the Mountain states plus western parts of some adjacent states": "America/Denver",
  "UTC−06:00 (CT) – Central Time zone: a large area spanning from the Gulf Coast to the Great Lakes": "America/Chicago",
  "UTC−05:00 (ET) – Eastern Time zone: roughly a triangle covering all the states from the Great Lakes down to Florida and east to the Atlantic coast": "America/New_York",
  "UTC−04:00 (AST) – Puerto Rico, the U.S. Virgin Islands": "America/Puerto_Rico",
  "UTC+10:00 (ChT)": "Pacific/Guam", // Guam and the Northern Mariana Islands
  "UTC+10:00 (ChT) – Guam and the Northern Mariana Islands": "Pacific/Guam",
  "UTC+12:00 (WAKT)": "Pacific/Wake", // Wake Island
  "UTC+12:00 (WAKT) – Wake Island": "Pacific/Wake",
  "UTC−11:00 (SST)": "Pacific/Pago_Pago",
  "UTC−10:00 (HT)": "Pacific/Honolulu",
  "UTC−09:30 (MART)": "Pacific/Marquesas",
  "UTC−09:00 (AKT)": "America/Anchorage",
  "UTC−08:00 (PT)": "America/Los_Angeles",
  "UTC−07:00 (MT)": "America/Denver",
  "UTC−06:00 (CT)": "America/Chicago",
  "UTC−05:00 (ET)": "America/New_York",
  "UTC−04:00 (AST)": "America/Halifax",
  "UTC−04:00 (VET)": "America/Caracas",
  "UTC−04:00 (AST)": "America/Puerto_Rico",
  "UTC−03:30 (NST)": "America/St_Johns",
  "UTC−03:00 (BRT)": "America/Sao_Paulo",
  "UTC±00:00 (GMT)": "Europe/London",
  "UTC+01:00 (CET)": "Europe/Paris",
  "UTC+02:00 (EET)": "Europe/Bucharest",
  "UTC+03:00 (MSK)": "Europe/Moscow",
  "UTC+03:30 (IRST)": "Asia/Tehran",
  "UTC+04:00 (GST)": "Asia/Dubai",
  "UTC+05:00 (PKT)": "Asia/Karachi",
  "UTC+05:30 (IST)": "Asia/Kolkata",
  "UTC+06:00 (BST)": "Asia/Dhaka",
  "UTC+07:00 (ICT)": "Asia/Bangkok",
  "UTC+08:00 (CST)": "Asia/Shanghai",
  "UTC+08:30 (KST)": "Asia/Pyongyang",
  "UTC+09:00 (JST)": "Asia/Tokyo",
  "UTC+09:30 (ACST)": "Australia/Adelaide",
  "UTC+10:00 (AEST)": "Australia/Sydney",
  "UTC+10:30 (LHST)": "Australia/Lord_Howe",
  "UTC+11:00 (SBT)": "Pacific/Guadalcanal",
  "UTC+12:00 (NZST)": "Pacific/Auckland",
  "Pacific/Pago_Pago":  "Pacific/Pago_Pago",
  "Pacific/Honolulu": "Pacific/Honolulu",
  "Pacific/Marquesas": "Pacific/Marquesas",
  "America/Anchorage": "America/Anchorage",
  "America/Los_Angeles": "America/Los_Angeles",
  "America/Denver": "America/Denver",
  "America/Chicago": "America/Chicago",
  "America/New_York": "America/New_York",
  "America/Halifax": "America/Halifax",
  "America/Caracas":"America/Caracas",
  "America/Puerto_Rico": "America/Puerto_Rico",
  "America/St_Johns": "America/St_Johns",
  "America/Sao_Paulo": "America/Sao_Paulo",
  "Europe/London": "Europe/London",
  "Europe/Paris": "Europe/Paris",
  "Europe/Bucharest": "Europe/Bucharest",
  "Europe/Moscow": "Europe/Moscow",
  "Asia/Tehran": "Asia/Tehran",
  "Asia/Dubai": "Asia/Dubai",
  "Asia/Karachi": "Asia/Karachi",
  "Asia/Kolkata": "Asia/Kolkata",
  "Asia/Colombo": "Asia/Colombo",
  "Asia/Dhaka": "Asia/Dhaka",
  "Asia/Bangkok": "Asia/Bangkok",
  "Asia/Shanghai": "Asia/Shanghai",
  "Asia/Tokyo": "Asia/Tokyo",
  "Australia/Adelaide": "Australia/Adelaide",
  "Australia/Sydney": "Australia/Sydney",
  "Australia/Lord_Howe": "Australia/Lord_Howe",
  "Pacific/Guadalcanal": "Pacific/Guadalcanal",
  "Pacific/Auckland": "Pacific/Auckland"
};

export const getTimeZone = (userTimezone) => {
  const zone = tzMap[userTimezone] || 'UTC';
  const customerTime = moment().tz(zone).format('YYYY-MM-DD HH:mm a z');
  const ampm = moment().tz(zone).format('A');
  return { zone, customerTime, ampm };
};

export const convertToUTC = (dateTimeStr, tzLabel) => {

  const ianaZone = tzMap[tzLabel] || 'UTC';

  // 1) strip the Z if it exists, because we want to treat it as LOCAL
  const clean = dateTimeStr.replace(/Z$/, '');

  // 2) parse as that local timezone
  const localMoment = moment.tz(clean, ianaZone);
  if (!localMoment.isValid()) return null;

  // 3) return UTC
  return localMoment.utc().format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');

};

export const convertToUnix = (dateTimeStr) => {

  let clean = dateTimeStr.replace(/Z$/, '');

  let localMoment = moment.tz(clean, "UTC").valueOf();;

  if (!localMoment) return null;

  return localMoment;

};

export const getTodayUtcRangeForGuide = (tzLabel) => {
  const ianaZone = tzMap[tzLabel] || 'UTC';

  // current time in guide's timezone
  const now = moment.tz(ianaZone);

  // start of "today" in guide's local time
  const startOfDayLocal = now.clone()

  // start of "tomorrow" in guide's local time
  const endOfDayLocal = startOfDayLocal.clone().add(1, 'day');

  // convert those to UTC dates for Mongo query
  const startUtc = startOfDayLocal.clone().utc().toDate();
  const endUtc   = endOfDayLocal.clone().utc().toDate();
  const startUnix = startOfDayLocal.clone().utc().valueOf();
  const endUnix = endOfDayLocal.clone().utc().valueOf();

  return { startUtc, endUtc, ianaZone, startUnix, endUnix };
}

export const getTomorrowUtcRangeForGuide = (tzLabel) => {
  const ianaZone = tzMap[tzLabel] || 'UTC';

  // current time in guide's timezone
  const now = moment.tz(ianaZone);

  // start of "tomorrow" in guide's local time
  const todayLocal = now.clone().startOf('day');
  const startOfTomorrowLocal = todayLocal.clone().add(1, 'day');

  // start of "day after tomorrow" in guide's local time
  const endOfTomorrowLocal = startOfTomorrowLocal.clone().add(1, 'day');

  // convert those to UTC dates for Mongo query
  const startUtc = startOfTomorrowLocal.clone().utc().toDate();
  const endUtc   = endOfTomorrowLocal.clone().utc().toDate();
  const startUnix = startOfTomorrowLocal.clone().utc().valueOf();
  const endUnix = endOfTomorrowLocal.clone().utc().valueOf();

  return { startUtc, endUtc, ianaZone, startUnix, endUnix };
}

export const getNextSevenDaysUtcRangeForGuide = (tzLabel) => {
  const ianaZone = tzMap[tzLabel] || 'UTC';

  // current time in guide's timezone
  const now = moment.tz(ianaZone);

  const todayLocal = now.clone().startOf('day');
  const startOfTomorrowLocal = todayLocal.clone().add(1, 'day');

  // start of "next week" in guide's local time
  const endOfWeekLocal = startOfTomorrowLocal.clone().add(7, 'days');

  // convert those to UTC dates for Mongo query
  const startUtc = startOfTomorrowLocal.clone().utc().toDate();
  const endUtc   = endOfWeekLocal.clone().utc().toDate();
  const startUnix = startOfTomorrowLocal.clone().utc().valueOf();
  const endUnix = endOfWeekLocal.clone().utc().valueOf();

  return { startUtc, endUtc, ianaZone, startUnix, endUnix };

}